/**
 * Optional fof/forum-widgets-core integration. When that extension is enabled,
 * "Upcoming events" registers as a managed widget so admins place it with the
 * widget manager; without it, nothing changes (the stock sidebar mount in
 * forum/index.ts keeps working). Resolved through flarum.reg at runtime — no
 * build-time dependency, so the bundle never breaks when the core is absent.
 *
 * Registered from BOTH frontends (the widget manager's admin UI lists widgets
 * by their class metadata); the admin side passes no content renderer.
 */
export default function registerFofWidget(app, makeContent) {
  var _flarum, _flarum$reg, _flarum$reg$get, _flarum$reg2, _flarum$reg2$get, _widgetsMod$default, _widgetMod$default;
  if (!((_flarum = flarum) != null && _flarum.extensions) || !('fof-forum-widgets-core' in flarum.extensions)) return;
  const widgetsMod = (_flarum$reg = flarum.reg) == null || (_flarum$reg$get = _flarum$reg.get) == null ? void 0 : _flarum$reg$get.call(_flarum$reg, 'fof-forum-widgets-core', 'common/extend/Widgets');
  const widgetMod = (_flarum$reg2 = flarum.reg) == null || (_flarum$reg2$get = _flarum$reg2.get) == null ? void 0 : _flarum$reg2$get.call(_flarum$reg2, 'fof-forum-widgets-core', 'common/components/Widget');
  const Widgets = (_widgetsMod$default = widgetsMod == null ? void 0 : widgetsMod.default) != null ? _widgetsMod$default : widgetsMod;
  const WidgetBase = (_widgetMod$default = widgetMod == null ? void 0 : widgetMod.default) != null ? _widgetMod$default : widgetMod;
  if (!Widgets || !WidgetBase) return;
  class CalendarUpcomingWidget extends WidgetBase {
    className() {
      // Flat: UpcomingEvents draws its own card + heading, so skip the
      // widget-core container chrome to avoid a double header.
      return 'CalendarFofWidget FofWidgets-Widget--flat';
    }
    header() {
      // The component renders its own heading (with a Calendar link) — the
      // chrome title on top of it read as a duplicate.
      return null;
    }
    icon() {
      return 'fas fa-calendar-days';
    }
    title() {
      return app.translator.trans('ernestdefoe-calendar.forum.widget_title');
    }
    content() {
      return makeContent ? makeContent() : null;
    }
  }
  new Widgets().add({
    key: 'calendarUpcoming',
    component: CalendarUpcomingWidget,
    isDisabled: false,
    isUnique: true,
    placement: 'end',
    position: 1
  }).extend(app, 'ernestdefoe-calendar');
}
flarum.reg.add('ernestdefoe-calendar', 'common/registerFofWidget', registerFofWidget);